import { render, staticRenderFns } from "./SocTableItemDescription.vue?vue&type=template&id=7457fadc&scoped=true&lang=pug"
import script from "./SocTableItemDescription.vue?vue&type=script&lang=ts"
export * from "./SocTableItemDescription.vue?vue&type=script&lang=ts"
import style0 from "./SocTableItemDescription.vue?vue&type=style&index=0&id=7457fadc&prod&lang=sass"
import style1 from "./SocTableItemDescription.vue?vue&type=style&index=1&id=7457fadc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7457fadc",
  null
  
)

export default component.exports